import { render, staticRenderFns } from "./privacidad-web.html?vue&type=template&id=5a1ae1af&"
import script from "./privacidad-web.ts?vue&type=script&lang=ts&"
export * from "./privacidad-web.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports